module.exports = __webpack_public_path__ + "img/just_like_mobile.13c65890.png";